import { Sentry } from 'src/sentry';

/**
 * `onDecodeError` for `parseGroupKeysFromGroupRowIds`. A malformed escape
 * means the row id did not come from `encodeGroupRowSegment`. The parse falls
 * back to the raw segment, which matches no group key, so the fetch returns an
 * empty group — indistinguishable from a group that really is empty unless the
 * decode failure itself is reported.
 */
export function reportGroupRowIdDecodeError(error: unknown, groupRowId: string) {
  Sentry.captureException(error, {
    extra: { groupRowId },
    tags: { component: 'parse-group-key-from-group-row-id' },
  });
}
